import { createContext } from 'react';

import emot, { type Emot } from './emot';

export interface StoreContextValue {
  emot: Emot;
}

const storeContext = createContext<StoreContextValue>({ emot });

export default storeContext;
